import LOD from "@arcgis/core/layers/support/LOD";
import { ILayerGroupService, IRaskLayer } from "./components/widgets/layer-list/models/layer-list.models";

export const layers = {

    AdministrativaGranser: {
        id: "AdministrativaGranser",
        title: "Administrativa gränser",
        services: [
            {
                id: "AdministrativaGranser",
                layersInService: [
                {
                    id: 0,
                    title: "Marknadsområden",
                    parentLayerId: -1
                } as unknown as IRaskLayer,
                {
                    id: 1,
                    title: "Regioner",
                    parentLayerId: -1
                },
                {
                    id: 2,
                    title: "Produktionsområden",
                    parentLayerId: -1
                },
                {
                    id: 3,
                    title: "Teamområden",
                    parentLayerId: -1
                },
                {
                    id: 4,
                    title: "LKD",
                    parentLayerId: -1
                },
                {
                    id: 5,
                    title: "LKF",
                    parentLayerId: -1
                },
                {
                    id: 6,
                    title: "Sveaskog Fastigheter",
                    parentLayerId: -1,
                    subLayerIds: [
                        7,
                        8,
                        9
                    ]
                },
                {
                    id: 7,
                    title: "Sveaskogs Skiften",
                    parentLayerId: 6
                },
                {
                    id: 13,
                    parentLayerId: 6,
                    title: "Belastning - Ytor"
                },
                {
                    id: 16,
                    parentLayerId: 13,
                    title: "Naturreservat"
                }
                ] as unknown as IRaskLayer[]
            }
        ] as unknown as ILayerGroupService[]
    },

    FornKulturminnen: {
        id: "FornKulturminnen",
        title: "Forn- och kulturminnen",
        services: [
            {
                id: "FornKulturminnen"
            }
        ]
    },

    Laserprodukter: {
        id: "Laserprodukter",
        title: "Laserprodukter",
        services: [
            {
                id: "Laserprodukter"
            }
        ]
    },

    MetriaFastighetsgranser: {
        id: "MetriaFastighetsgranser",
        title: "Metria Fastighetsgränser",
        services: [
            {
                id: "MetriaFastighetsgranser",
                layersInService: undefined
            }
        ]
    },

    Restriktioner: {
        id: "Restriktioner",
        title: "Restriktioner",
        services: [
            {
                id: "Restriktioner"
            }
        ]
    }
};

export const mapConfiguration = {
    arbetsorderKarta: {
        dynamicFeatureLayersIdList: [
            "MetriaFastighetsgranser",
            "Naturhansyn",
            "Restriktioner",
            "AdministrativaGranser",
            "FornKulturminnen",
            "Vagar",
            "Atgarder",
            "Atgarder_selection",
            "Laserprodukter",
            "Allmanna_ytor_linjer_punkter"
        ],
        layerGroups: [
            layers.MetriaFastighetsgranser,
            {
                id: "Naturhansyn",
                title: "Naturhänsyn",
                services: [
                    {
                        id: "Naturhansyn"
                    }
                ]
            },
            layers.Restriktioner,
            layers.AdministrativaGranser,
            layers.FornKulturminnen,
            {
                id: "Vagar",
                title: "Vägar",
                services: [
                    {
                        id: "Vagar"
                    }
                ]
            },
            layers.Laserprodukter,
            {
                id: "Allmanna_ytor_linjer_punkter",
                title: "Allmänna ytor linjer punkter",
                services: [
                    {
                        id: "Allmanna_ytor_linjer_punkter"
                    }
                ]
            }
        ]
    },
    virkeskopKarta: {
        dynamicFeatureLayersIdList: [
            "Collector",
            "Arbetsorder",
            "Arboreal",
            "Virkeskop",
            "MetriaFastighetsgranser",
            "Restriktioner",
            "AdministrativaGranser",
            "FornKulturminnen",
            "Laserprodukter",
            "Egen_skog"
        ],
        layerGroups: [
            {
                id: "Collector",
                title: "Field Maps",
                services: [
                    {
                        id: "Collector"
                    }
                ]
            },
            {
                id: "Arbetsorder",
                title: "Arbetsorder",
                services: [
                    {
                        id: "Arbetsorder"
                    }
                ]
            },
            {
                id: "Arboreal",
                title: "Arboreal",
                services: [
                    {
                        id: "Arboreal"
                    }
                ]
            },
            {
                id: "Virkeskop",
                title: "Virkesköp",
                services: [
                    {
                        id: "Virkeskop"
                    }
                ]
            },
            layers.MetriaFastighetsgranser,
            layers.Restriktioner,
            layers.AdministrativaGranser,
            layers.FornKulturminnen,
            {
                id: "Laserprodukter",
                title: "Laserprodukter",
                services: [
                    {
                        id: "Laserprodukter"
                    }
                ]
            },
            {
                id: "Egen_skog",
                title: "Egen skog",
                services: [
                    {
                        id: "Egen_skog"
                    }
                ]
            }
        ]
    }
};

export const preloadedMetriaLODs: LOD[] = [
    {
        level: 0,
        resolution: 2116.670900008467,
        scale: 8000000
    },
    {
        level: 1,
        resolution: 1058.3354500042335,
        scale: 4000000
    },
    {
        level: 2,
        resolution: 529.1677250021168,
        scale: 2000000
    },
    {
        level: 3,
        resolution: 264.5838625010584,
        scale: 1000000
    },
    {
        level: 4,
        resolution: 132.2919312505292,
        scale: 500000
    },
    {
        level: 5,
        resolution: 66.1459656252646,
        scale: 250000
    },
    {
        level: 6,
        resolution: 26.458386250105836,
        scale: 100000
    },
    {
        level: 7,
        resolution: 19.843789687579378,
        scale: 75000
    },
    {
        level: 8,
        resolution: 13.229193125052918,
        scale: 50000
    },
    {
        level: 9,
        resolution: 7.9375158750317505,
        scale: 30000
    },
    {
        level: 10,
        resolution: 5.291677250021167,
        scale: 20000
    },
    {
        level: 11,
        resolution: 2.6458386250105836,
        scale: 10000
    },
    {
        level: 12,
        resolution: 1.3229193125052918,
        scale: 5000
    },
    {
        level: 13,
        resolution: 0.5291677250021167,
        scale: 2000
    },
    {
        level: 14,
        resolution: 0.26458386250105836,
        scale: 1000
    }
] as LOD[];
